import { render, staticRenderFns } from "./LmsLessonContent.vue?vue&type=template&id=31d968ea&scoped=true"
import script from "./LmsLessonContent.vue?vue&type=script&lang=js"
export * from "./LmsLessonContent.vue?vue&type=script&lang=js"
import style0 from "./LmsLessonContent.vue?vue&type=style&index=0&id=31d968ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d968ea",
  null
  
)

export default component.exports